import React, { useEffect, useRef } from 'react';
import { Common } from '../../utils/common';
import PropTypes from 'prop-types';
import moment from 'moment';

const $ = window.$;

function LeadDetailsTable({ tableData, isAutomotiveIndustry }) {
  const tableEl = useRef(null);

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      columns: columnBuilder(isAutomotiveIndustry),
      dom: '<fB>tlip',
      keys: true,
      lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, 'All'],
      ],

      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        var index = iDisplayIndexFull + 1 + '.';
        $('td:eq(0)', nRow).html(index);
        return nRow;
      },

      stateSave: true,

      stateSaveCallback: function (_oSettings, oData) {
        if (!Common.in_crm_mode()) {
          localStorage.setItem('DataTables-AI-Lead_Details', JSON.stringify(oData));
        }
      },

      stateLoadCallback: function () {
        if (!Common.in_crm_mode()) {
          return JSON.parse(localStorage.getItem('DataTables-AI-Lead_Details'));
        }
      },

      buttons: [
        {
          extend: 'colvis',
          text: 'Select Columns',
          titleAttr: 'Select Columns',
          collectionLayout: 'three-column',
          columns: ':gt(0)',
        },
        {
          extend: 'excelHtml5',
          text: 'Data Export',
          title: 'WebForm_Details_Export',
          titleAttr: 'Export as Excel',
          exportOptions: {
            columns: (i) => {
              const hideFromExport = isAutomotiveIndustry ? [0, 12, 20] : [0, 15];
              const isVisible = table.column(i).visible();
              const isNotForExport = hideFromExport.includes(i);
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columnDefs: [{ className: 'table_cell_centered_text', targets: '_all' }],
      paging: true,
      responsive: true,
      destroy: true,
      order: [1, 'desc'],
    });
    table.clear();
    if (tableData) {
      table.rows.add(tableData).draw();
    }
    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
      $el.empty();
    };
  }, [tableData, isAutomotiveIndustry]);

  return (
    <div className='table-responsive' style={{ paddingTop: '20px' }}>
      <table
        ref={tableEl}
        className='table table-hover table-striped vertical_centered table-bordered'
        style={{ width: '100%' }}
      ></table>
    </div>
  );
}

function columnBuilder(isAutomotiveIndustry) {
  const columns = [];
  columns.push({
    data: null,
    render: () => '&nbsp;',
    searchable: false,
    orderable: false,
  });
  columns.push({
    data: 'created_at',
    title: 'Time of WebForm',
    render: (data) => moment.utc(data).local().format('MMM D, YYYY hh:mm:ss A'),
  });
  columns.push({ data: 'landing_domain', title: 'Domain', visible: false });
  columns.push({ data: 'form_name', title: 'Form Name', visible: false });
  columns.push({ data: 'name', title: 'Name' });
  columns.push({
    data: 'phone',
    title: 'Phone',
    render: (data, type, row) => {
      const formattedNumber = Common.formatPhoneNumber(data);
      if (Common.in_crm_mode()) {
        return formattedNumber;
      } else if (formattedNumber && row.global_id) {
        return `<a href="/visitors/${row.global_id}/activity/${row.site}" target='_self'>${formattedNumber}</a>`;
      } else {
        return formattedNumber;
      }
    },
  });
  columns.push({
    data: 'email',
    title: 'Email',
    render: (data, type, row) => {
      if (Common.in_crm_mode()) {
        return data;
      } else if (data && row.global_id) {
        return `<a href="/visitors/${row.global_id}/activity/${row.site}" target='_self'>${data}</a>`;
      } else {
        return data;
      }
    },
  });
  columns.push({ data: 'comments', title: 'Comments', visible: false });
  if (isAutomotiveIndustry) {
    columns.push({ data: 'vin', title: 'VIN', visible: false });
    columns.push({ data: 'year', title: 'Year', visible: false });
    columns.push({ data: 'make', title: 'Make', visible: false });
    columns.push({ data: 'model', title: 'Model', visible: false });
    columns.push({
      data: null,
      title: 'Vehicle',
      render: (data, type, row) => {
        if (row.image_url) {
          return `
            <a href=${row.landing_url} target="_blank" class="landing_url">
              <img src=${row.image_url} class="vehicle_image" onerror="javascript:Common.imageError(this);" />
            </a>
          `;
        } else {
          return null;
        }
      },
    });
  }
  columns.push({ data: 'ref_domain', title: 'Referral' });
  columns.push({ data: 'ref_medium', title: 'Medium' });
  columns.push({ data: 'utm_source', title: 'UTM Source', visible: false });
  columns.push({ data: 'utm_medium', title: 'UTM Medium', visible: false });
  columns.push({ data: 'utm_campaign', title: 'UTM Campaign', visible: false });
  columns.push({ data: 'utm_content', title: 'UTM Content', visible: false });
  columns.push({ data: 'utm_term', title: 'Keyword', visible: false });
  columns.push({
    data: 'landing_url',
    title: 'Form Submitted On Link',
    render: (data) => `<a href=${data} target='_blank'>WebSite</a>`,
    visible: false,
  });
  columns.push({ data: 'landing_url', title: 'RAW URL Submitted On', visible: false });
  return columns;
}

LeadDetailsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  isAutomotiveIndustry: PropTypes.bool.isRequired,
};

export default LeadDetailsTable;
